import { queryBpInfos, queryLatestGps } from '@/api/device'

const device = {
  state: {
    bpInfos: {
      devicesInfo: [
        { lebal: '', value: '' },
        { lebal: '', value: '' },
        { lebal: '', value: '' }
      ],
      paramsInfo: [
        { lebal: '0', value: '0' },
        { lebal: '0', value: '0' },
        { lebal: '0', value: '0' },
        { lebal: '0', value: '0' },
        { lebal: '0', value: '0' },
        { lebal: '0', value: '0' }
      ],
      devName: '',
      testTime: '2022-4-16 10:10:10'
    },
    devicesState: {}
  },

  mutations: {
    SET_BMAP_INFOS: (state, bpInfos) => {
      state.bpInfos = bpInfos
    }
  },

  actions: {
    // 登录
    async queryBpInfos({ commit }, devid) {
      const response = await queryBpInfos(devid)
      return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
    },
    async queryLatestGps({ commit }, userid) {
      const response = await queryLatestGps(userid)
      return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
    }
  }
}

export default device
